import script from "./InitialLiquidity.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitialLiquidity.vue?vue&type=script&setup=true&lang=ts"

import "./InitialLiquidity.vue?vue&type=style&index=0&id=d9fee9d4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9fee9d4"]])

export default __exports__